/**
 * Configuration constants for the magician module.
 */

/** Default minimum milliseconds between UI updates during streaming */
export const DEFAULT_UPDATE_INTERVAL = 150;

/** Delay in milliseconds for batching chunk processing */
export const CHUNK_PROCESSING_DELAY = 10;

/** Default value for trackCall parameter */
export const DEFAULT_TRACK_CALL = false;

/** Default LLM model for magician operations */
export const DEFAULT_LLM_MODEL = 'cw_Qwen_Qwen3-Coder-480B-A35B-Instruct';
